






























import { Emit, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class ConfirmDialog extends Vue {
  @Prop() title!: string;
  @Prop() confirmText!: string;

  @VModel({ type: Boolean }) dialog: boolean;

  loading = false;

  @Emit() onOk() {}

  @Watch('dialog')
  onDialogChange(val, oldVal) {
    if (!val) {
      this.loading = false;
    }
  }
}
